<template>
  <div class="animated fadeIn mt-3" id="report">
    <h1 class="text-uppercase font-weight-bold">Estadísticas Procesos</h1>
    <b-card id="element-to-hide" data-html2canvas-ignore="true">
      <b-row>
        <b-col sm="12" md="6" lg="2">
          <b-form-group label="Exportadora">
            <b-form-select
              size="sm"
              id="client_customer"
              v-model="client_customer"
              :options="client_customer_options"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="6" lg="2">
          <b-form-group label="Especie">
            <b-form-select size="sm" id="product" v-model="product" :options="product_options"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="6" lg="2">
          <b-form-group label="Tipo proceso">
            <b-form-select
              size="sm"
              id="process_type"
              v-model="process_type"
              :options="process_type_options"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="6" lg="3">
          <b-form-group label="Desde">
            <b-form-datepicker
              size="sm"
              placeholder="dd-mm-aaaa"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              :max="maxDate"
              locale="es"
              v-model="from_date"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="6" lg="3">
          <b-form-group label="Hasta">
            <b-form-datepicker
              size="sm"
              placeholder="dd-mm-aaaa"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              locale="es"
              :max="maxDate"
              v-model="to_date"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
    <div>
      <kpis
        :from_date="from_date"
        :to_date="to_date"
        :client_customer="client_customer"
        :process_type="process_type"
        :product="product"
        v-if="ready"
        @chart-ready="beginChartMount($event)"
      />

      <b-card-group v-if="beginMount.length">
        <b-card v-if="beginMount[0]">
          <div class="chart-wrapper chart">
            <daily-process
              chartId="daily-process"
              :from_date="from_date"
              :to_date="to_date"
              :client_customer="client_customer"
              :process_type="process_type"
              :product="product"
              v-if="ready"
              @chart-ready="beginChartMount($event)"
            />
          </div>
        </b-card>
      </b-card-group>
      <b-card-group v-if="beginMount.length">
        <b-card v-if="beginMount[1]">
          <div class="chart-wrapper chart">
            <total-product-type
              chartId="daily-process"
              :from_date="from_date"
              :to_date="to_date"
              :client_customer="client_customer"
              :process_type="process_type"
              :product="product"
              v-if="ready"
              @chart-ready="beginChartMount($event)"
            />
          </div>
        </b-card>
        <b-card v-if="beginMount[1]">
          <div class="chart-wrapper chart">
            <total-process-room
              chartId="daily-process"
              :from_date="from_date"
              :to_date="to_date"
              :client_customer="client_customer"
              :process_type="process_type"
              :product="product"
              v-if="ready"
              @chart-ready="beginChartMount($event)"
            />
          </div>
        </b-card>
        <b-card v-if="beginMount[1]">
          <div class="chart-wrapper chart">
            <total-container
              chartId="total-container"
              :from_date="from_date"
              :to_date="to_date"
              :client_customer="client_customer"
              :process_type="process_type"
              :product="product"
              v-if="ready"
              @chart-ready="beginChartMount($event)"
            />
          </div>
        </b-card>
      </b-card-group>
      <b-card-group v-if="beginMount.length">
        <b-card v-if="beginMount[4]">
          <div class="chart-wrapper chart">
            <daily-shift
              chartId="daily-shift"
              :from_date="from_date"
              :to_date="to_date"
              :client_customer="client_customer"
              :process_type="process_type"
              :product="product"
              v-if="ready"
              @chart-ready="beginChartMount($event)"
            />
          </div>
        </b-card>
      </b-card-group>
      <b-card-group v-if="beginMount.length">
        <b-card v-if="beginMount[5]">
          <div class="chart-wrapper chart">
            <top-ten-growers
              chartId="top-ten-growers"
              :from_date="from_date"
              :to_date="to_date"
              :client_customer="client_customer"
              :process_type="process_type"
              :product="product"
              v-if="ready"
              @chart-ready="beginChartMount($event)"
            />
          </div>
        </b-card>
        <b-card no-body v-if="beginMount[5]">
          <div class="chart-wrapper chart">
            <all-processes
              chartId="all-processes"
              :from_date="from_date"
              :to_date="to_date"
              :client_customer="client_customer"
              :process_type="process_type"
              :product="product"
              v-if="ready"
              @chart-ready="beginChartMount($event)"
            />
          </div>
        </b-card>
      </b-card-group>
    </div>
  </div>
</template>
<script>
import Kpis from "./Kpis.vue";
import DailyProcess from "./DailyProcess.vue";
import DailyShift from "./DailyShift.vue";
import TotalProductType from "./TotalProductType.vue";
import TotalProcessRoom from "./TotalProcessRoom.vue";
import TopTenGrowers from "./TopTenGrowers.vue";
import TotalContainer from "./TotalContainer.vue";
import AllProcesses from "./AllProcesses.vue";

export default {
  name: "charts",
  components: {
    Kpis,
    DailyProcess,
    DailyShift,
    TotalProcessRoom,
    TotalProductType,
    TotalContainer,
    TopTenGrowers,
    AllProcesses
  },
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    // 15th two months prior
    const minDate = new Date(today);
    minDate.setMonth(minDate.getMonth() - 1);
    // 15th in two months
    const maxDate = new Date(today);

    return {
      ready: false,
      beginMount: [],
      minDate: minDate,
      maxDate: maxDate,
      from_date: minDate.toISOString().split("T")[0],
      to_date: now.toISOString().split("T")[0],
      product: null,
      product_options: [],
      process_type: null,
      process_type_options: [],
      client_customer: null,
      client_customer_options: []
    };
  },
  watch: {
    client_customer(newVal, oldVal) {
      this.refreshData();
    },
    from_date(newVal, oldVal) {
      this.refreshData();
    },
    to_date(newVal, oldVal) {
      this.refreshData();
    },
    product(newVal, oldVal) {
      this.refreshData();
    },
    process_type(newVal, oldVal) {
      this.refreshData();
    }
  },
  methods: {
    beginChartMount(bool) {
      this.beginMount.push(true);
    },
    downloadReport() {
      const element = document.getElementById("report");
      const opt = {
        margin: 0.5,
        image: { type: "jpeg", quality: 0.98 },
        filename: "Estadisticas Recepcion_" + this.from_date + "-" + this.to_date + ".pdf",
        html2canvas: { dpi: 192, letterRendering: true },
        jsPDF: { unit: "in", format: "letter", orientation: "p" }
      };
      html2pdf().from(element).set(opt).save();
    },
    refreshData() {
      this.beginMount = [];
      this.ready = false;
      this.$nextTick((_) => {
        this.ready = true;
      });
    },
    getCustomers() {
      this.$axios
        .get("/production/get_customers/")
        .then((res) => {
          const data = res.data.data;
          const customers = [];
          for (let key in data) {
            const customer = data[key];
            customers.push(customer);
          }
          this.client_customer_options = customers;
          this.client_customer_options.unshift({ text: "Todo", value: null });
        })
        .catch((error) => console.log(error));
    },
    getProducts() {
      this.$axios
        .get("/production/get_products/")
        .then((res) => {
          const data = res.data.data;
          const products = [];
          for (let key in data) {
            const product = data[key];
            products.push(product);
          }
          this.product_options = products;
          this.product_options.unshift({ text: "Todo", value: null });
        })
        .catch((error) => console.log(error));
    },
    getProcessTypes() {
      this.$axios
        .get("/production/get_process_types/")
        .then((res) => {
          const data = res.data.data;
          const products = [];
          for (let key in data) {
            const product = data[key];
            products.push(product);
          }
          this.process_type_options = products;
          this.process_type_options.unshift({ text: "Todo", value: null });
        })
        .catch((error) => console.log(error));
    }
  },
  async mounted() {
    this.loading = true;
    this.getCustomers();
    this.getProducts();
    this.getProcessTypes();
    this.ready = true;
  }
};
</script>

<style scoped>
.chart {
  max-height: 300px;
}
</style>
